import { isValidEmail } from '../../../utils/emailUtils';

export interface ParsedEmails {
    valid: string[];
    invalid: string[];
}

// Extracts emails from pasted text. Handles plain, "Name <email>", mailto:,
// markdown links, and tokens wrapped in quotes/brackets/punctuation. Tokens
// with @ that fail validation are returned as invalid, tokens without @ are dropped
export function parseEmails(raw: string): ParsedEmails {

    // Split on list separators. Keep <...> and mailto:
    const parts = raw
        .split(/[,;\t\n]+/)
        .map((value) => value.trim())
        .filter(Boolean)
        .flatMap((part) => {
            if (part.includes('<') || /mailto:/i.test(part)) return [part];
            return part.split(/\s+/);
        });

    const valid = new Set<string>();
    const invalid = new Set<string>();

    for (const part of parts) {
        // try format extractors on the raw token first
        const markdownMatch = part.match(/\[.*?\]\(mailto:([^)]+)\)/);
        const angleMatch = part.match(/<(?:mailto:)?([^>]+)>/);
        let candidate: string;
        if (markdownMatch) {
            candidate = markdownMatch[1];
        } else if (angleMatch) {
            candidate = angleMatch[1];
        } else {
            // Strip leading wrappers so the mailto: anchor can match, then drop the prefix
            candidate = stripWrapping(part).replace(/^mailto:/i, '');
        }
        candidate = stripWrapping(candidate);

        if (!candidate) continue;

        if (isValidEmail(candidate)) {
            valid.add(candidate.toLowerCase());
        } else if (candidate.includes('@')) {
            invalid.add(candidate.toLowerCase());
        }
    }

    return { valid: Array.from(valid), invalid: Array.from(invalid) };
}

// Wrapping characters to strip from the ends of a token
const WRAPPER_CHARS = /^["'`“”‘’[({\s]+|["'`“”‘’\])}:;.\s]+$/g;

function stripWrapping(value: string): string {
    return value.replace(WRAPPER_CHARS, '');
}

export function shouldHandlePastedInviteText(value: string): boolean {
    return (
        value.includes(',') ||
        value.includes(';') ||
        value.includes('\t') ||
        value.includes('\n') ||
        value.includes('<') ||
        /mailto:/i.test(value) ||
        (value.includes('@') && value.includes(' '))
    );
}
